module Meevo.Plugins.Services {
  "use strict";
  /**
  * NotesSection Section -- need aggregate model for handling functionality.
  */
  export class NotesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Service> {
      constructor(
          sectionId: number,
          displayNameContentKey: string,
          template: string,
          isPrimarySection: boolean,
          handlesOwnCrud: boolean,
          baseEndpoint: string,
          sectionEndpoint: string,
          loggingService: Meevo.Components.Logging.ILoggingService,
          dataService: Meevo.Components.BaseClasses.IDataService,
          protected identityService: Meevo.Components.Common.IIdentityService = null,
          protected securityService: Meevo.Components.Common.ISecurityService,
          noun: Meevo.Model.NounEnum = null,
          appSettings?: Components.Common.IAppSettings,
          sectionSecurityKey?: string,
          protected translateService?: angular.translate.ITranslateService,
          protected modalService?: Meevo.Components.Modal.IModalService
     ) {
          super(
              sectionId,
              displayNameContentKey,
              template,
              isPrimarySection,
              handlesOwnCrud,
              baseEndpoint,
              sectionEndpoint,
              loggingService,
              dataService,
              identityService,
              noun,
              appSettings,
              sectionSecurityKey,
              translateService
          );
      }

    createNewServiceNote() {
          return this.dataService.getTemplate(this.baseEndpoint, this.parentItemId, "notes");
      }

      public OnEditItem(item: any, actionOnItem: { (item: any): void }) {
          var url = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/${this.parentItemId}/NotesNewOptions`;

          this.dataService
              .customMethodData(url, "GET", null)
              .then((response) => {
                  item.canSetOnBookingType = response.data.canSetOnBookingType || item.isAppointmentType;
                  item.canSetCheckinType = response.data.canSetCheckinType || item.isCheckinType;
                  item.canSetRegisterType = response.data.canSetRegisterType || item.isRegisterType;

                  actionOnItem(item);
              });
      }

  }
}